// extracted by mini-css-extract-plugin
module.exports = {"chatBoxMain":"ChatBox_chatBoxMain__3_yND","backButtonContainer":"ChatBox_backButtonContainer__2FXO8","chatsListContainer":"ChatBox_chatsListContainer__3Di2I"};